import { useLoader } from "react-three-fiber"
import { TextureLoader } from "three"
import React, { useRef, forwardRef, useImperativeHandle } from 'react'

const TextureAnimation = forwardRef(({ image, frameNum }, ref) => {
	const material = useRef(null)
	const texture = useLoader(TextureLoader, image)
	texture.repeat.set(1 / frameNum, 1)
	texture.offset.x = 0

	/*
	setCurrentFrame を親要素から呼べるようにする
	(forwardRef と useImpperativeHandle の機能)
	*/
	useImperativeHandle(ref, () => ({
		setCurrentFrame: (newFrame) => {
			material.current.map.offset.x = (newFrame < frameNum) ? newFrame / frameNum : 0
		}
	}))

	return (
		<spriteMaterial ref={material} attach="material" map={texture} fog={true} />
	)
})

export default TextureAnimation